import { connect } from 'react-redux';
import fetchIntercomInfo from '../../../api/intercom/intercomActions';
import { selectors } from '../../../root/reading/root';
import config from '../../../configs/reading';
import Intercom from '../../../features/intercom/Intercom';

const mapStateToProps = state => ({
    intercomInfo: selectors.getIntercomInfo(state, config.views),
    isIntercomInfoFetched: selectors.isIntercomInfoFetched(state),
});

const mapDispatchToProps = dispatch => ({
    fetchIntercomInfo: setUserHash => {
        dispatch(fetchIntercomInfo(setUserHash));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Intercom);
